module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-fa9391ffafcbf9f74f146405db6a499c.png";